import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, FormHelperText, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useSnackbar } from "notistack";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";

const SkillDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const theme = useTheme();
  const [skill, setSkill] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();
  const [value, setValue] = useState({});
  const limit = 10;
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setSkill(props.data);
  }, [props.data]);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createSkill = async (data: any) => {
    try {
      setIsSubmitting(true);
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/skills?type==${theme.theme}&page=${page}&items_per_page=${limit}`;

      const res = await axiosInstance.post(url, {
        skill_name: data.skill_name,
        description: data.description,
        type: theme.theme,
      });
      enqueueSnackbar("Skill Created Successfully!!!", { variant: "success" });
      handleClose("created");

    } catch (err: any) {
      enqueueSnackbar(
        `Skill Creation Unsuccessful!!! ${err.response.data.error}`,
        { variant: "error" }
      );
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  const editSkill = async (data: any) => {

    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/skills/${data.id}`;

    axiosInstance
      .put(url, {
        skill_name: data.skill_name,
        description: data.description,
        type: theme.theme,
      })
      .then((response) => {
        enqueueSnackbar("Skill Updated Successfully!!!", {
          variant: "success",
        });
      })
      .catch((err: any) => {
        enqueueSnackbar(
          `Skill Updatation Unsuccessfull!!!! ${err.response.data.error}`,
          {
            variant: "error",
          }
        );
      });

    handleClose();
  };

  return (
    <>
      {" "}
      {skill == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Skill :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Skill </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Skill :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    skill_name: "",
                    description: "",
                  }
                  : skill
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                skill_name: Yup.string()
                  .required("Skill is Required")
                  .max(125, "Skill must not be greater than 15 characters"),

                description: Yup.string().max(
                  125,
                  "Description must not be greater than 8 characters"
                ),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createSkill
                  : editSkill
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2 mt-2 ">
                  <div className="flex flex-col space-y-1 mr-6">

                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="outlined-multiline-flexible"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.skill_name}
                      placeholder="Enter Skill"
                      label="Skill"
                      required
                      name="skill_name"
                      error={Boolean(errors.title && touched.title)}
                      helperText={
                        errors.title && touched.title && String(errors.title)
                      }
                    />
                  </div>

                  <div className="flex flex-col space-y-1 mr-6">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="outlined-multiline-flexible"
                      maxRows={2}
                      label="Description"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.description || ""}
                      placeholder="Enter Description"
                      name="description"
                      error={Boolean(errors.title && touched.title)}
                      helperText={
                        errors.title && touched.title && String(errors.title)
                      }
                    />
                  </div>

                  <div className="flex py-3 space-x-4 justify-start">
                    {props.dialogAction != EDialogAction.view ? (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleSubmit()}
                          disabled={isSubmitting}
                          style={{ display: isSubmitting ? "none" : "inline-flex" }}
                        >
                          {props.dialogAction == EDialogAction.edit ? "Update" : "Create"}
                        </Button>
                        {isSubmitting && <CircularProgress size={24} />}
                      </>
                    ) : null}
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleClose()}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default SkillDialogBox;
